import React from "react";

import UserContext from '../../Contexts/UserContext';

import styles from './Lemma.module.css';

const DeleteLemma = props => {
  const [style, setStyle] = React.useState({display: 'none'});
  const [deleteInput, setDeleteInput] = React.useState('');
  const {user} = React.useContext(UserContext);

  // Delete only if the user typed the word DELETE (case-insensitive).
  // This works even for empty/blank lemmata, unlike the old version which
  // asked the user to retype the (often blank) "original" field. – fix
  const startDeletionProcess = e => {
    e.preventDefault();
    const confirmed = deleteInput.trim().toLowerCase() === 'delete';
    setDeleteInput('');
    if (confirmed) {
      props.deleteLemma(props.lemma.lemmaId);
    } else {
      alert('Not deleted. To delete, type the word DELETE and press return.');
    }
  };

  const onChange = e => {
    setDeleteInput(e.target.value);
  }

  return (
    <div
      className={styles.deleteLemma}
      onClick={e => {
        setStyle({display: 'block'});
      }}
      onMouseLeave={e => {
        setStyle({display: 'none'});
      }}
      style={{display: (user.token ? 'block' : 'none')}}
    >
      <h3>Delete Lemma</h3>
      <form style={style} onSubmit={startDeletionProcess}>
        <p>
          To delete this lemma, type <b>DELETE</b> below and press return.
        </p>
        <p>
          Deleting cannot be undone!
        </p>
        <p>&nbsp;</p>
        <div>
          <input
            type="text"
            id="delete-confirm"
            className={styles.inputDelete}
            placeholder="type DELETE"
            value={deleteInput}
            onChange={onChange}
          />
        </div>
      </form>
    </div>
  );
};

export default DeleteLemma;
